<div>
  <submission-loading v-if="!isReadyStateComplete()" :id="$vId(this)" />
  <div v-if="isReadyStateComplete()">
    <div class="mt-block">  
      <div class="mt-wrapper">
        <div class="mt-group" v-if="submission.status === 'rejected' && !submission.isLive">
          <div>
            <h1 class="mt-h1">
              {{$t('pages.submissions.details.family_name_overview', {familyName: submissionFamilyName})}}
            </h1>
          </div>
          <div class="mt-10">
            <h4 class="mt-h4">{{$t('pages.submissions.details.status_notification.rejected.title')}}</h4>
          </div>
        </div>

        <div class="mt-group" v-if="submission.status === 'live' && isEditable">
          <div>
            <h1 class="mt-h1">
              {{$t('pages.submissions.details.family_name_overview', {familyName: submissionFamilyName})}}
            </h1>
          </div>
          <div class="mt-15">
            <p class="mt-serif mt-serif--size4" v-html="$t('pages.submissions.details.description')"></p>
            <p
              class="mt-serif mt-serif--size4"
              v-if="isPackagePriceEmpty()"
              v-html="$sanitize($t('pages.submissions.details.live_description'))"
            ></p>
          </div>
          <div class="mt-20 mb-25">
            <button
              @click="navigateToLiveEdit(submission.id)"
              type="button"
              :id="$vId(this, 'correct')"
              class="mt-button"
            >
              {{$t('pages.submissions.details.status_notification.live.live')}}
            </button>
          </div>
        </div>
        <div class="mt-group" v-if="submission.status === 'live' && !isEditable">
          <div>
            <h1 class="mt-h1">
              {{$t('pages.submissions.details.family_name_overview', {familyName: submissionFamilyName})}}
            </h1>
          </div>
          <div class="mt-15">
            <p class="mt-serif mt-serif--size4" v-html="$t('pages.submissions.details.non_description')"></p>
            <p
              class="mt-serif mt-serif--size4"
              v-if="isPackagePriceEmpty()"
              v-html="$sanitize($t('pages.submissions.details.live_description'))"
            ></p>
          </div>
          <div class="mt-20 mb-25">
            <button
              :disabled="!isEditable"
              @click="navigateToLiveEdit(submission.id)"
              type="button"
              :id="$vId(this, 'correct')"
              class="mt-button"
            >
              {{$t('pages.submissions.details.status_notification.live.live')}}
            </button>
          </div>
        </div>

        <div class="mt-group" v-if="submission.status === 'approved'">
          <div>
            <h1 class="mt-h1">
              {{$t('pages.submissions.details.family_name_overview', {familyName: submissionFamilyName})}}
            </h1>
          </div>
          <div class="mt-15">
            <h4 class="mt-h4">{{$t('pages.submissions.details.status_notification.approved.title')}}</h4>
          </div>
          <div class="mt-15">
            <p class="mt-serif mt-serif--size4">
              {{$t('pages.submissions.details.status_notification.approved.text')}}
            </p>
          </div>
        </div>

        <div class="mt-group" v-if="submission.status === 'in_correction'">
          <div>
            <h1 class="mt-h1">
              {{$t('pages.submissions.details.family_name_overview', {familyName: submissionFamilyName})}}
            </h1>
          </div>
          <div class="mt-15">
            <p class="mt-serif mt-serif--size4" v-html="$t('pages.submissions.details.description')"></p>
            <p
              class="mt-serif mt-serif--size4"
              v-if="isPackagePriceEmpty()"
              v-html="$sanitize($t('pages.submissions.details.live_description'))"
            ></p>
          </div>
          <div class="mt-15">
            <h4 class="mt-h4">{{$t('pages.submissions.details.status_notification.in_correction.title')}}</h4>
          </div>
          <div class="mt-15">
            <p class="mt-serif mt-serif--size4">
              {{$t('pages.submissions.details.status_notification.in_correction.text')}}
            </p>
          </div>
          <div class="mt-20 mb-25">
            <button
              type="button"
              :id="$vId(this, 'correct')"
              class="mt-button"
              @click="navigateToCorrect(submission.id)"
            >
              {{$t('pages.submissions.details.status_notification.in_correction.correct')}}
            </button>
          </div>
        </div>
        <message-history v-if="submission.status" :id="$vId(this, 'message-history')" :messageHistory="submission.messageHistory">
        </message-history>
        <fou-group bottom="large" v-if="submission.status">
          <fou-container :id="$vId(this, 'family-approve')" cols="12" background padded>
            <template #header>
              <div class="row">
                <div class="col is9">
                  <h5 class="mt-h5">{{$t('pages.submissions.details.title')}}</h5>
                </div>
                <div
                  v-if="submission.status === 'live' && submissionFormatsLength"
                  class="col is1"
                  :class="[$style.mL35]"
                >
                  <select
                    class="mt-select"
                    v-model="selected"
                    @change="navigateToReview(selected)"
                    :disabled="selected === null || disableFormat"
                    :class="selected === null || disableFormat ? [$style.newSelectDisabled, $style.selectWidthCapitalize] : [$style.newSelect, $style.selectTextSpacing]"
                  >
                    <option
                      v-for="format, index in isFormatAvailable(submission.userMetaData)"
                      :key="index"
                      :value="format.formatId"
                    >
                      {{format.name}}
                    </option>
                  </select>
                </div>
              </div>
              <span v-if="submission.status === 'live' && submissionFormatsLength" class="mt-error" v-html="$t('pages.submissions.details.more_info')"></span>
            </template>

            <template #content>
              <div v-if="Object.keys(this.submissionFamily).length !== 0">
                <fou-preview
                  :expandText="$t('pages.submissions.details.expand.trigger.more')"
                  :collapseText="$t('pages.submissions.details.expand.trigger.less')"
                  :toggleStyle="{ marginLeft: '2.85rem', marginTop: '1.25rem' }"
                >
                  <template #content>
                    <preview :id="$vId(this)" />
                  </template>
                </fou-preview>
              </div>
            </template>
          </fou-container>
        </fou-group>

        <fou-group>
          <v-grid>
            <v-row>
              <v-col has="10">
                <div class="out-right">
                  <fou-group v-if="submission.status === 'rejected' && submission.isLive">
                    <h2 class="mt-h3">{{$t('pages.submissions.details.status_notification.rejected_live.title')}}</h2>
                    <fou-group>
                      <p class="mt-serif mt-serif--size2">
                        {{$t('pages.submissions.details.status_notification.rejected_live.text')}}
                      </p>
                    </fou-group>
                  </fou-group>

                  <fou-group v-if="submission.status === 'in_review'">
                    <h2 class="mt-h3">{{$t('pages.submissions.details.status_notification.review.title')}}</h2>
                    <fou-group>
                      <p class="mt-serif mt-serif--size2">
                        {{$t('pages.submissions.details.status_notification.review.text')}}
                      </p>
                    </fou-group>
                  </fou-group>
                </div>
              </v-col>
            </v-row>
          </v-grid>
        </fou-group>
      </div>
    </div>
  </div>
</div>
